<template>
  <v-layout align-center column>
    <div class="page Function">
 
      <div class="Feature">
        <div style="width:150px;">
          <a><span class="Tab-Title">Semua Kategori</span>
         
         </a>
          <hr@click="filterPage('')"  class="Active-Line" v-if="filter == ''"/>
        </div>
         
       

         <div style="width:150px;">
        <a @click="filterPage('Literasi Finansial')"><span class="Tab-Title">Literasi Finansial</span></a>
                <hr  class="Active-Line" v-if="filter == 'Literasi Finansial'"/>


        </div>

         <div style="width:140px;">
        <a @click="filterPage('Tips Keuangan')"><span class="Tab-Title">Tips Keuangan</span></a>
        <hr  class="Active-Line" v-if="filter == 'Tips Keuangan'"/>


        </div>

        <div style="width:100px;">
        <a @click="filterPage('Ekonomi')"><span class="Tab-Title">Ekonomi</span></a>
        <hr  class="Active-Line" v-if="filter == 'Ekonomi'"/>

        </div>

        <div style="width:140px;">
        <a @click="filterPage('Tech & Bisnis')"><span class="Tab-Title">Tech & Bisnis</span></a>
        <hr  class="Active-Line" v-if="filter == 'Tech & Bisnis'"/>

        </div>

        <div style="width:90px;">
        <a @click="filterPage('Fintech')"><span class="Tab-Title">Fintech</span></a>
        <hr  class="Active-Line" v-if="filter =='Fintech'"/>

        </div>

        <div style="width:60px;">
        <a @click="filterPage('FAQ')"><span class="Tab-Title">FAQ</span></a>
        <hr  class="Active-Line" v-if="filter == 'FAQ'"/>

        </div>

        <div style="width:80px;">
        <a @click="filterPage('Pilihan')"><span class="Tab-Title">Pilihan</span></a>
        <hr  class="Active-Line" v-if="filter == 'Pilihan'"/>

        </div>
        <div class="Search">
          <input class="input-search" placeholder="Search..."/><img src="../../assets/BlogList/search.png"

     srcset="../../assets/BlogList/search@2x.png 2x,

             ../../assets/BlogList/search@3x.png 3x"

     class="search">
             <hr  class="Separator" />

        </div>

      </div>
    </div>
    <hr/>
    <div style="width:1100px;">
        <v-row  v-bind:style="{margin:`0 ${marginBlogCard} 0 ${marginBlogCard}`}">
            <blog-card v-for="data in blogs" :key="data" :data="data" />
        </v-row>
      
    </div>
    <div  class="text-center" style="width:1100px;">
     <v-pagination
            style="
              border-top: solid 0.6px;
              border-color: #b5b5b5;

              padding-top: 14px;
            "
            v-model="pagination.page"
            :length="pagination.pages"
            circle
            light
            color="black"
            @input="next"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
          ></v-pagination>
    </div>
  </v-layout>
</template>
<script>
import BlogCard from "./BlogCard.vue";
export default {
  components: { BlogCard },
  data() {
    return {
      marginBlogCard: "",
      search: "",
      filter: '',
      pagination: {
      page: 1,
      pages: 5,
    },
      page : 1,
      blogs: [
        {
          id: 1,
          image: require("../../assets/BlogList/1/Blog-Image.png"),
          title: "Resensi Kilat: Rich Dad Poor Dad karangan Robert Kiyosaki",
          author: "Fadhel Yafie",
          date: "Feb 27, 2021",
          desc:
            "Saat liburan sekolah, Jimmy mengundang banyak temannya ke resort mewah milik orang tuanya. Hanya ada dua orang yang tidak diundang...",
          category: "Literasi Finansial",
          subCategory: "Tips Keuangan",
        },
        {
           id: 2,
          image: require("../../assets/BlogList/2/Blog-Image.png"),
          title: "Ingin Investasi Saham? Pelajari Dulu Penjelasan tentang Saham!",
          author: "Fadhel Yafie",
          date: "Feb 18, 2021",
          desc:
            "Halo Sobat Kilat! Sadar gak kalau belakangan ini banyak banget orang yang ngomongin saham? Gak sedikit juga yang mulai coba-coba...",
          category: "Ekonomi",
          subCategory: "Literasi Finansial",
        },
        {
           id: 3,
          image: require("../../assets/BlogList/3/Blog-Image.png"),
          title: "Mungkinkah Kecerdasan Buatan Menggantikan Pekerjaan Manusia?",
          author: "Fadhel Yafie",
          date: "Feb 26, 2021",
          desc:
            "Kecepatan perkembangan teknologi sedang dalam tahap yang paling cepat sepanjang sejarah. Sobat Kilat bisa membayangkan 10 tahun...",
          category: "Ekonomi",
          subCategory: "Tech & Bisnis",
        },
        {
           id: 4,
          image: require("../../assets/BlogList/4/Blog-Image.png"),
          title: "7 Baby Steps a la Dave Ramsey Menuju “Financial Freedom",
          author: "Fadhel Yafie",
          date: "Feb 26, 2021",
          desc:
            "Cara cepat untuk mencapai financial freedom itu mudah: Jangan mengeluarkan uang. Bercanda. Mana mungkin bisa hidup tanpa...",
          category: "Literasi Finansial",
          subCategory: "Tips Keuangan",
        },
        {
           id: 5,
          image: require("../../assets/BlogList/5/Blog-Image.png"),
          title: "Kuasai 10 Keterampilan Ini Agar Dibutuhkan di Pasar Kerja Masa Depan",
          author: "Fadhel Yafie",
          date: "Feb 18, 2021",
          desc:
            "Kuasai 10 Keterampilan Ini Agar Dibutuhkan di Pasar Kerja Masa Depan. Kita sudah sering kali mendengar berita tentang era disrupsi...",
          category: "Ekonomi",
          subCategory: "Tech & Bisnis",
        },
        {
           id: 6,
          image: require("../../assets/BlogList/6/Blog-Image.png"),
          title: "Perhatikan Hal Ini Sebelum Menggunakan Layanan Paylater!",
          author: "Fadhel Yafie",
          date: "Feb 18, 2021",
          desc:
            "Pandemi Covid-19 mempengaruhi jutaan pekerja di Indonesia. Menurut data dari Badan Pusat Statistik (BPS), sekitar 29,12 juta...",
          category: "Fintech",
          subCategory: "Literasi Finansial",
        },
        {
           id: 7,
          image: require("../../assets/BlogList/7/Blog-Image.png"),
          title: "Memahami Resesi Ekonomi: Definisi, Penyebab hingga Dampaknya",
          author: "Fadhel Yafie",
          date: "Feb 11, 2021",
          desc:
            "Pandemi COVID-19 memiliki dampak yang sangat besar terhadap perekonomian dunia. Beberapa negara di tahun 2020 kemarin...",
          category: "Ekonomi",
          subCategory: "Tech & Bisnis",
        },
         {
            id: 8,
          image: require("../../assets/BlogList/8/Blog-Image.png"),
          title: "Cerita Singkat Dompet Kilat Mendapat Izin Operasional OJK",
          author: "Fadhel Yafie",
          date: "Feb 18, 2021",
          desc:
            "Dompet Kilat merupakan salah satu fintech lending yang pertama kali mendapatkan izin operasional dari Otoritas Jasa Keuangan (OJK)...",
          category: "FAQ",
          subCategory: "Pilihan",
        },
         {
            id: 9,
          image: require("../../assets/BlogList/9/Blog-Image.png"),
          title: "Hal-Hal yang Perlu Kamu Ketahui Seputar Fintech Lending Dompet Kilat",
          author: "Fadhel Yafie",
          date: "Feb 18, 2021",
          desc:
            "Sebelumnya Sobat sudah berkenalan dengan fintech melalui tulisan ini. Pada kesempatan kali ini tim Dompet Kilat ingin memberi informasi...",
          category: "FAQ",
          subCategory: "",
        },
      ],
    };
  },
   mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginBlogCard = `${window.innerWidth / 200  }px`;
     
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    filterPage(text){
      this.filter = text;
    }
  },
};
</script>
<style scoped>
.tabs {
  margin-bottom: 200px;
}
.blog-list {
  height: 1000px;
  z-index: 999;
}
.page {
  text-align: center;
  width: 100%;
  margin : -750px 0 100px 0;
  /* margin-top: -900px; */
  position: relative;
  background-color: white;
    background-color: #000000;

}
.Feature {
  width: 1200px;
  display: flex;
  height: 70px;
  margin: 30px auto 0px auto;
  /* padding: 19px 0px 20px 0px; */
}
.Tab-Title {
  /* width: 115px; */
  height: 20px;
  flex-grow: 0;
  /* margin: 0 26px 6px 2px; */
  font-family: Sora;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: right;
  color: #ffffff;
}
.Active-Line {
  /* width: 119px; */
  height: 2px;
  flex-grow: 0;
  margin: 6px 8px 0 8px;
  background-color: #d3352c;
}
.search {
  width: 18px;
  height: 18px;
  flex-grow: 0;
  /* margin: 2px 6px 16px 62px; */
  object-fit: contain;
}
.Separator {
  width: 132px;
  height: 1px;
  flex-grow: 0;
  margin: 14px 0 0;
  background-color: #ffffff;
}
.Search {
  width: 132px;
  height: 37px;
  flex-grow: 0;
  margin: 0 0 0 88px;
}
.input-search{
  width: 100px;
  color: #ffffff;
}
.Next {
  width: 32px;
  height: 32px;
  flex-grow: 0;
  margin: 0 0 0px 407px;
  object-fit: contain;
}
.Back {
  width: 32px;
  height: 32px;
  flex-grow: 0;
  margin: 0px 412px 0 0;
  object-fit: contain;
}
[aria-label="Next page"] {
  position: absolute;
  right: 0;
}
[aria-label="Previous page"] {
  position: absolute;
  left: 0;
}
</style>
